import React, {useRef, PropsWithChildren, RefObject} from 'react';
import useOutsideClick from '../../Foundations/Hooks/UseOutsideClick';

interface IProps {
    className?: string;
    onClickOutside?(ref?: React.RefObject<HTMLDivElement>): void;
    triggerRef?: RefObject<HTMLButtonElement | HTMLElement | HTMLDivElement | HTMLInputElement | null>;
    doubleWidth?: boolean;
}

const Dropdown: React.FC<IProps> = (props: PropsWithChildren<IProps>) => {
    const ref = useRef<HTMLDivElement | null>(null);

    useOutsideClick(ref, () => {
        if (typeof props.onClickOutside !== 'undefined') {
            props.onClickOutside(ref);
        }
    }, props.triggerRef);

   return (
       <div ref={ref}
            className={`${typeof props.className !== 'undefined' ? props.className : ''}  ${props.doubleWidth === true ? 'w-double left-0' : 'w-full'} origin-top-right absolute right-0 rounded-md shadow shadow-2xl bg-white ring-1 ring-black ring-opacity-5`}
       >
           {props.children}
       </div>
   );
};

export default Dropdown;
